import { useEffect, useState } from 'react';
import PermissionService from '../services/permissionService';

const ProtectedRoute = ({ children, requiredPermissions = [], fallbackScreen = 'dashboard', goTo }) => {
  const [hasAccess, setHasAccess] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      // If no permissions required, allow access
      if (!requiredPermissions || requiredPermissions.length === 0) {
        setHasAccess(true);
        setChecking(false);
        return;
      }

      try {
        const hasPermission = await PermissionService.hasAnyPermission(requiredPermissions);
        setHasAccess(hasPermission);
        
        if (!hasPermission) {
          console.warn('⛔ Access denied - insufficient permissions');
          console.warn('   Required:', requiredPermissions);
          // Redirect to fallback screen
          setTimeout(() => goTo(fallbackScreen), 100);
        }
      } catch (error) {
        console.error('Error checking permissions:', error);
        setHasAccess(false);
      } finally {
        setChecking(false);
      }
    };

    checkAccess();
  }, [requiredPermissions, fallbackScreen, goTo]);

  if (checking) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        🔐 Checking permissions...
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        padding: '20px',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '64px', marginBottom: '20px' }}>🔒</div>
        <h2 style={{ color: '#333', marginBottom: '10px' }}>Access Denied</h2>
        <p style={{ color: '#666', marginBottom: '20px' }}>
          You don't have permission to access this page.
        </p>
        <p style={{ fontSize: '14px', color: '#999' }}>
          Redirecting to dashboard...
        </p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
